import { FirebaseApp, initializeApp } from 'firebase/app'
import {
  getRemoteConfig,
  getValue,
  RemoteConfig,
  Value,
  fetchAndActivate,
} from 'firebase/remote-config'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

let app: FirebaseApp

export const initializeFirebase = (): FirebaseApp => {
  if (!app) {
    app = initializeApp(firebaseConfig)
  }
  return app
}

export class FirebaseRemoteConfig {
  remoteConfig: RemoteConfig

  constructor() {
    this.remoteConfig = getRemoteConfig(initializeFirebase())
  }

  async getUrlPlayStore(): Promise<string> {
    await fetchAndActivate(this.remoteConfig)
    const value: Value = getValue(this.remoteConfig, 'play_store_url')
    return value.asString()
  }

  async getUrlAppleStore(): Promise<string> {
    await fetchAndActivate(this.remoteConfig)
    const value: Value = getValue(this.remoteConfig, 'app_store_url')
    return value.asString()
  }
}

const firebaseRemoteConfig = new FirebaseRemoteConfig()
export { firebaseRemoteConfig }
